import {

  RefreshLine,
  DepositMoney, TransferMoney,
} from "@datanomik/commons-ui/icons";

export const CashPoolingExceedIcon = () => <DepositMoney sx={{
  transform: 'rotate(180deg)',
}} />;
export const CashPoolingMinimumIcon = () => <TransferMoney sx={{
  transform: 'rotate(180deg)',
}} />;
export const CashPoolingFixedIcon = () => <RefreshLine />;
